 
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const MrpRoutes: RouteObject[] = [
  {
    path: 'MRP/*',
    children: [
      { path: 'Settings/Processes', lazy: lazyRoute(() => import('../../pages/MRP/Processes/Index')) },
      { path: 'Settings/Products', lazy: lazyRoute(() => import('../../pages/MRP/Products/Index')) },
      { path: 'Settings/Products/AddProduct', lazy: lazyRoute(() => import('../../pages/MRP/Products/Add2')) }
    ]
  }
];

export default MrpRoutes;
